import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import Select from 'react-select'
import DatePicker from "react-datepicker";
import CalendarContainer from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import './style.scss';
import $t from 'services/i18n'
import CFG from 'config'

export const LABEL_STATUS_AGENCY = {
  'PENDING': 'order.status.pending',  // 0,3,7,8,9
  'OK': 'order.status.confirmed',     // 1
  'KO': 'order.status.cancelled',     // 2,4
  'REFUNDED': 'order.status.refunded',  // 5,6
  // 'CANCELLATION_REQUESTED': 'refundticket.booking.cancellation_requested', // not yet present
  'CANCELLATION_ERROR': 'refundticket.booking.cancellation_error'   // 91
}

class Filters extends Component {

  constructor(props) {
    super(props);

    this.isB2bAgency = CFG.appId === 'b2b-agency'

    const STATUS_FILTER = this.isB2bAgency ? {
      /**
       * just for B2B agency, the BI endpoint aggregates statuses as it is done by core APIs (same map).
       */
      '0,3,7,8,9': { label: $t(LABEL_STATUS_AGENCY['PENDING'])},
      '1': { label: $t(LABEL_STATUS_AGENCY['OK'])},
      '2,4': { label: $t(LABEL_STATUS_AGENCY['KO'])},
      '5,6': { label: $t(LABEL_STATUS_AGENCY['REFUNDED'])},
      '91': { label: $t(LABEL_STATUS_AGENCY['CANCELLATION_ERROR'])}
    } : {
      0: { label: 'Pending' },
      1: { label: 'Booking confirmed' },
      // 2: { label: '@@Missing label status = 2@@' },
      3: { label: 'Need confirm' },
      4: { label: 'Confirm refused' },
      5: { label: 'Partly refunded' },
      6: { label: 'Refunded' },
      7: { label: 'In booking' },
      8: { label: 'Waiting confirm' },
    };

    this.state = {
      activityKeyword: "",
      activities: [],
      selectedActivity: null,
      textFilters: [
        {
          id: "nmTitle",
          label: $t('order.property.activity.title', {default: "Activity title"}),
          value: "",
        },
        {
          id: "idOrder",
          label: $t('orderstable.booking.number', {default: "Order ID"}),
          value: "",
        },
        {
          id: "nmLastNameHolder",
          label: $t('order.property.lastname', {default: "Last name"}),
          value: "",
        },
        ...(this.isB2bAgency ? [{
          id: "ulEmailHolder",
          label: $t('order.property.email', {default: "Email"}),
          value: "",
        }] : [])
      ],
      statusFilter: STATUS_FILTER,
      selectedStatus: props.filterStatus ? [props.filterStatus] : [],
      serviceFrom: null,
      serviceTo: null,
      bookingFrom: moment().subtract(1, 'months').toDate(),
      bookingTo: null,
    };

    this.onActivitySelectChange = this.onActivitySelectChange.bind(this);
    this.onTextInputChange = this.onTextInputChange.bind(this);
  }

  componentWillMount() {
    this.updateParent();
  }

  updateParent() {
    const { selectedActivity, textFilters, selectedStatus, serviceFrom, serviceTo, bookingFrom, bookingTo } = this.state;
    const textFilterQuery = textFilters.map(f => {
      let value = f.value;
      if (f.id === "idOrder") {
        value = value.replace('mus0', "");
        value = value.replace('MUS0', "");
        value = value.replace('mus', "");
        value = value.replace('MUS', "");
      }
      return value ? `&${f.id}=${value}` : '';
    }).join("");

    const statusFilterQuery = selectedStatus.length > 0 ? `&cditemStatus IN (${selectedStatus.join(",")})` : '';
    const serviceDateFromFilterQuery = serviceFrom ? `&dtService>='${moment(serviceFrom).format("YYYY-MM-DD")}'` : '';
    const serviceDateToFilterQuery = serviceTo ? `&dtService<='${moment(serviceTo).format("YYYY-MM-DD")}'` : '';
    const bookingDateFromFilterQuery = bookingFrom ? `&dtBooked>='${moment(bookingFrom).format("YYYY-MM-DD")}'` : '';
    const bookingDateToFilterQuery = bookingTo ? `&dtBooked<='${moment(bookingTo).format("YYYY-MM-DD")}'` : '';

    const activityId = selectedActivity ? `&idEventUUID='${selectedActivity.value}'` : "";

    this.props.updateFunction([textFilterQuery, statusFilterQuery, serviceDateFromFilterQuery, serviceDateToFilterQuery, bookingDateFromFilterQuery, bookingDateToFilterQuery, activityId].join(""));
  }

  onActivitySelectChange(e) {
    this.setState({ activityKeyword: e }, () => this.fetchActivity(this.state.activityKeyword));
  }

  onTextInputChange(e) {
    window.parent.postMessage({field: e.target.id, value: e.target.value}, "*");
    const { textFilters } = this.state;
    textFilters.forEach(f => {
      if (f.id === e.target.id) f.value = e.target.value;
    });
    this.setState({ textFilters });
  }

  trackingCalendar(field, date){
    window.parent.postMessage({field: field, value: moment(date).format("DD/MM/YY")}, "*");
  }

  handleServiceFrom(from) {
    const datesDiff = from - this.state.serviceTo;
    this.setState({ serviceFrom: from, serviceTo: datesDiff > 0 ? null : this.state.serviceTo });
    this.trackingCalendar("service_date_from", from);
  }

  handleServiceTo(to) {
    const datesDiff = to - this.state.serviceFrom;
    this.setState({ serviceTo: datesDiff > 0 ? to : this.state.serviceTo });
    this.trackingCalendar("service_date_to", to);
  }

  handleBookingFrom(from) {
    const datesDiff = from - this.state.bookingTo;
    this.setState({ bookingFrom: from, bookingTo: datesDiff > 0 ? null : this.state.bookingTo });
    this.trackingCalendar("booking_date_from", from);
  }

  handleBookingTo(to) {
    const datesDiff = to - this.state.bookingFrom;
    this.setState({ bookingTo: datesDiff > 0 ? to : this.state.bookingTo });
    this.trackingCalendar("booking_date_to", to);
  }

  trackingClickStatus(actionTypes){
    if(actionTypes.action === "select-option"){
      window.parent.postMessage({field: "selected_status", value: actionTypes.option.label}, "*");
    } else if(actionTypes.action === "remove-value"){
      window.parent.postMessage({field: "unselect_status", value: actionTypes.removedValue.label}, "*");
    }
  }
  trackingSearchStatus(query){
    if(query){
      window.parent.postMessage({field: "search_status", value: query}, "*");
    }
  }

  fetchActivity(keyword) {
    if (keyword.length > 2) {
      axios
        .get(`https://fe-apiproxy.musement.com/autocomplete?text=${keyword}&sort_by=-relevance&activity_limit=3&city_limit=2&venue_limit=2&list_limit=2`)
        .then(res => {
          if (res && res.data && Array.isArray(res.data)) {
            const responseActivities = res.data.find(d => d.type === "activities");
            this.setState({ activities: responseActivities && responseActivities.items ? responseActivities.items.map(i => { return { value: i.id, label: i.title } }) : [] });
          }
        })
        .catch(thrown => {
          console.log('[fetchActivity error]', thrown);
        });
    }
  }

  // Render methods

  activityInputRender() {
    const { activities } = this.state;
    return (
      <div key={0} className="filters-content-text-filter">
        <p className="filters-content-text-filter-label">Activity title</p>
        <Select placeholder={"Start typing"} options={activities} onInputChange={this.onActivitySelectChange} onChange={(selectedActivity) => this.setState({ selectedActivity })} className="filters-content-text-filter-select-container" classNamePrefix="filters-content-text-filter-select-container" />
      </div>
    );
  }

  textInputRender(f, index) {
    return (
      <div key={index} className="filters-content-text-filter">
        <p className="filters-content-text-filter-label">{f.label}</p>
        <input
          id={f.id}
          className="filters-content-text-filter-input"
          onChange={this.onTextInputChange}
          type="text"
          placeholder="Start typing"
          value={f.value}
        />
      </div>
    );
  }

  dateFromRender(date) {
    if (date) return <span>From: {moment(date).format("DD/MM/YY")}</span>;
    return <span>From: dd/mm/yy</span>;
  }

  dateToRender(date) {
    if (date) return <span>To: {moment(date).format("DD/MM/YY")}</span>;
    return <span>To: dd/mm/yy</span>;
  }

  calendarContainerRender({ className, children }) {
    return (
      <div style={{ padding: '16px', background: '#216ba5', color: '#fff' }}>
        <CalendarContainer className={className}>
          <div style={{ background: '#f0f0f0' }}>Clear</div>
          <div style={{ position: 'relative' }}>
            {children}
          </div>
        </CalendarContainer>
      </div>
    );
  }

  calendarFromRender(dateFrom, dateTo, clearMethod, onChangeMethod, calendarType) {
    return (
      <DatePicker
        // calendarContainer={this.calendarContainerRender}
        customInput={this.dateFromRender(dateFrom)}
        selectsStart
        showMonthDropdown
        showYearDropdown
        selected={dateFrom}
        startDate={dateFrom}
        endDate={dateTo}
        onChange={onChangeMethod}
        dropdownMode="select"
      ><p className="react-datepicker-clear"
        onClick={ () => {
          clearMethod();
          window.parent.postMessage({field: calendarType}, "*");
        }}>Clear</p></DatePicker>
    );
  }

  calendarToRender(dateFrom, dateTo, clearMethod, onChangeMethod, calendarType) {
    return (
      <DatePicker
        customInput={this.dateToRender(dateTo)}
        selectsEnd
        showMonthDropdown
        showYearDropdown
        selected={dateTo}
        startDate={dateFrom}
        endDate={dateTo}
        onChange={onChangeMethod}
        dropdownMode="select"
      ><p className="react-datepicker-clear" onClick={ () => {
        clearMethod();
        window.parent.postMessage({field: calendarType}, "*");
      }}>Clear</p></DatePicker>
    );
  }

  render() {
    const { textFilters, statusFilter, serviceFrom, serviceTo, bookingFrom, bookingTo, selectedStatus } = this.state;
    const { filterStatus } = this.props;
    const statusOptions = Object.keys(statusFilter).map(key => ({ ...statusFilter[key], value: key }));
    const statusValue = selectedStatus.map(statusCode => ({ value: statusCode, label: statusFilter[statusCode].label }));
    return (
      <div className="filters">
        <div className="filters-content">
          <div className="filters-content-text">
            {/* {this.activityInputRender()} */}
            {textFilters.map((f, i) => { return this.textInputRender(f, i + 1) })}
          </div>
          <div className="filters-content-dateandstatus">
            <div className="filters-content-dateandstatus-filter">
              <p className="filters-content-dateandstatus-filter-label">{$t('orderstable.service.date', {default: "Service date:"})}</p>
              <div className="filters-content-dateandstatus-filter-date">
                <div className="filters-content-dateandstatus-filter-date-from">
                  {this.calendarFromRender(serviceFrom, serviceTo, () => this.setState({ serviceFrom: null, serviceTo: null }), (date) => this.handleServiceFrom(date), "service_date_clear")}
                </div>
                <div className="filters-content-dateandstatus-filter-date-to">
                  {this.calendarToRender(serviceFrom, serviceTo, () => this.setState({ serviceFrom: null, serviceTo: null }), (date) => this.handleServiceTo(date), "service_date_clear")}
                </div>
              </div>
            </div>
            <div className="filters-content-dateandstatus-filter">
              <p className="filters-content-dateandstatus-filter-label">{$t('orderstable.confirmation.date', {default: "Booking date:"})}:</p>
              <div className="filters-content-dateandstatus-filter-date">
                <div className="filters-content-dateandstatus-filter-date-from">
                  {this.calendarFromRender(bookingFrom, bookingTo, () => this.setState({ bookingFrom: null, bookingTo: null }), (date) => this.handleBookingFrom(date), "booking_date_clear")}
                </div>
                <div className="filters-content-dateandstatus-filter-date-to">
                  {this.calendarToRender(bookingFrom, bookingTo, () => this.setState({ bookingFrom: null, bookingTo: null }), (date) => this.handleBookingTo(date), "booking_date_clear")}
                </div>
              </div>
            </div>
            <div className="filters-content-dateandstatus-filter">
              <p className="filters-content-dateandstatus-filter-label"></p>
              <Select
                placeholder={$t('common.label.status', {default: "Status"})}
                isMulti
                value={statusValue}
                options={statusOptions}
                onChange={(selectedStatus, actionTypes) => {
                  this.setState({ selectedStatus: selectedStatus.map(s => s.value) });
                  this.trackingClickStatus(actionTypes);
                }}
                onInputChange={this.trackingSearchStatus}
                onMenuOpen={() => { window.parent.postMessage({field: "status_accordion_open"}, "*"); }}
                onMenuClose={() => { window.parent.postMessage({field: "status_accordion_close"}, "*"); }}
                className="filters-content-dateandstatus-filter-select-container"
                classNamePrefix="filters-content-dateandstatus-filter-select-container"
                isDisabled={!!filterStatus} />
            </div>
          </div>
        </div>
        <button className="filters-searchbutton" onClick={() => {
          this.updateParent();
          window.parent.postMessage({field: "click_search_button"}, "*");
        }}>Search</button>

      </div>
    );
  }
}

export default Filters;
